import { ChangeEvent, FC, useContext, useEffect, useState } from 'react'
import Button from '../../../common/components/Button'
import styles from './TextExercise.module.css'
import { SwiperContext } from '../../../pages/Feed/Feed'
import { OnResponseSubmit, StepResponse } from '../../../types/Exercise'
import { t } from 'i18next'

interface TextExerciseProps {
  id: number
  onResponseSubmit: OnResponseSubmit
  stepResponse?: StepResponse
}

const TextExercise: FC<TextExerciseProps> = ({
  id,
  onResponseSubmit,
  stepResponse,
}) => {
  const { swiper } = useContext(SwiperContext)
  const [value, setValue] = useState<string>(stepResponse?.response || '')
  const maxCharacters = 160
  const [charactersLeft, setCharactersLeft] = useState<number>(maxCharacters)
  const [loading, setLoading] = useState(false)
  const disabled = stepResponse?.stepId === id || loading

  useEffect(() => {
    setValue(stepResponse?.response || '')
  }, [stepResponse?.response])

  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = event.target.value
    if (newValue.length <= maxCharacters) {
      setValue(newValue)
      setCharactersLeft(maxCharacters - newValue.length)
    }
  }
  const handleSendClick = async () => {
    setLoading(true)
    try {
      await onResponseSubmit(id, value)
    } catch (error) {
      console.error('Failed to submit response', error)
    }
    setLoading(false)
  }

  return (
    <div className={styles.inputContainer}>
      <label>{t('exercises.title')}</label>
      <textarea
        className={styles.inputArea}
        value={value}
        onFocus={() => swiper?.disable()}
        onBlur={() => swiper?.enable()}
        onChange={handleChange}
        rows={5}
        placeholder={t('exercises.maximumCharacters')}
      />
      <div className={styles.characterCounter}>{charactersLeft}</div>
      <Button
        title={t('exercises.save')}
        onClick={handleSendClick}
        disabled={disabled}
        backgroundColor={disabled ? 'disabled' : 'white'}
      />
    </div>
  )
}

export default TextExercise
